import { DemographicSocioeconomicGroupDto } from '@/core/api/dtos/response/demographicSocioeconomicGroup/demographicSocioeconomicGroup'
import { DemographicSocioeconomicGroup } from '@/core/api/entities/demographicSocioeconomicGroup'

export class DemographicSocioeconomicGroupMapper {
	public static toEntity(
		dto: DemographicSocioeconomicGroupDto
	): DemographicSocioeconomicGroup {
		return new DemographicSocioeconomicGroup(dto)
	}

	public static toDTO(
		entity: DemographicSocioeconomicGroup
	): DemographicSocioeconomicGroupDto {
		return entity.key
	}

	public static toEntities(
		dtos: DemographicSocioeconomicGroupDto[]
	): DemographicSocioeconomicGroup[] {
		return dtos.map(this.toEntity)
	}
}
